import { Navbar } from "react-bootstrap"
import styled from "styled-components"

export const StyledNavbar = styled(Navbar)`
  background: #fff;
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
`

// eslint-disable-next-line import/no-anonymous-default-export
export default {}
